<template>
  <v-container>
    <v-row dense>
      <v-col v-for="(component, i) in content" :key="i" cols="12">
        <Section
          :key="i"
          v-if="component.type == 'section'"
          :component="component"
          :index="i"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Section from "@/components/HomeSections/Section";

export default {
  name: "Homepage",
  components: {
    Section
  },
  data() {
    return {
      content: null
    };
  },
  beforeMount() {
    var data = require("@/assets/json/proprietaire.json");
    this.content = data.content;
  }
};
</script>
